<template>
  <div id="co-authorship-confirm-dialog"
       class="flex-center">
    <ipub-model width="1000px"
                class="copyright-documents"
                :visable="isVisable"
                @cancel="cancel"
                :showHeader="false"
                :showFooter="false">
      <div class="co-authorship-confirm-block">
        <div class="ipub-h4 mar-b-20 tips flex">
          <ipub-icon style="font-size:30px"
                     class="key-color"
                     type="iconDetails" />
          <font class="mar-l-12">Warning! You must submit this page to vertify your contribution to the submission.</font>
        </div>
        <div class="mar-b-30 ipub-p2">Please respond to the questions/statements below and click on the "Submit to Publication" button to complete your Co-Author verification for the submission. If you do not submit your responses, your contribution will not be confirmed.</div>
        <div class="question-list mar-b-30">
          <div v-for="item in questionList"
               class="mar-b-50"
               :key="item.questionId">
            <div class="ipub-p1 mar-b-10">
              <font v-if="item.required"
                    class="key-color">*</font>{{item.questionContent}}
            </div>
            <div v-if="item.type === 'QA'">
              <ipub-input v-model.trim="item.answer"
                          style="width: 800px"
                          placeholder="Input your answer" />
            </div>
            <div v-else-if="item.type === 'SINGLE'">
              <ipub-select v-model="item.checkedOption"
                           placeholder="Select your answer"
                           style="width: 400px">
                <ipub-select-option v-for="(val, num) in JSON.parse(item.questionOption)"
                                    :value="num"
                                    :key="val.answer + num">
                  {{val.answer}}
                </ipub-select-option>
              </ipub-select>
              <div v-if="(item.checkedOption || item.checkedOption===0) && JSON.parse(item.questionOption)[item.checkedOption].supplementary"
                   style="margin-top: 10px">
                <div class="ipub-p2 mar-b-10">
                  {{JSON.parse(item.questionOption)[item.checkedOption].supplementary}}
                </div>
                <div>
                  <ipub-input v-model.trim="item.supplyAnswer"
                              style="width: 800px"
                              placeholder="Input your answer" />
                </div>
              </div>
            </div>
            <div v-else-if="item.type === 'MULTIPLE'">
              <ipub-select v-model="item.checkedOptions"
                           placeholder="Select your answers"
                           mode="multiple"
                           optionKey="answer"
                           optionTitle="answer"
                           style="width: 400px"
                           :options="JSON.parse(item.questionOption)" />
            </div>
          </div>
        </div>
        <ipub-button type="primary"
                     @click="submit">
          Submit to Publication
        </ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import publisher from '@/api/publisher'
import file from '@/api/file'
import mauthor from '@/api/mauthor'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      publisher: {},
      article: {
        journal: {}
      },
      id: '',
      questionList: [],
      domain: ''
    }
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.id = ''
      } else {
        this.getPublisherInfo('' || 'imr')
        this.getArticle()
        this.getDomain()
      }
    }
  },
  mounted () {

  },
  methods: {
    async getPublisherInfo (id) {
      this.publisher = await publisher.query(id)
    },
    async getArticle () {
      try {
        this.id = this.inputData.coAuthor.code
        this.article = await mauthor.manuscript(this.id)
        this.questionnaire(this.article.journal.id)
      } catch (e) {
        this.$router.push('/other-author/notice/' + this.id)
      }
    },
    async questionnaire (id) {
      this.questionList = await mauthor.questionnaire(id)
      this.questionList.forEach(item => {
        item.questionId = item.id
        delete item.id
      })
    },
    async getDomain () {
      this.domain = await file.domain()
    },
    async submit () {
      const flag = this.questionList.some(item => {
        if (
          item.type === 'MULTIPLE' &&
          item.checkedOptions &&
          item.checkedOptions.length
        ) {
          item.checkedOption = item.checkedOptions.join(';')
        }
        if (
          item.required &&
          !(item.answer || item.checkedOption || item.checkedOption === 0)
        ) {
          return true
        }
      })
      if (flag) {
        this.$message.error({
          title: 'Error',
          content: 'Please complete the questionnaire'
        })
        return
      }
      try {
        await mauthor.decision(this.id, {
          status: 'CONFIRMED',
          questionList: this.questionList
        })

        this.$message.success({
          title: 'Success',
          content: 'Thanks for you submit'
        })
      } catch (e) {
        this.$router.push('/other-author/notice/' + this.id)
      }
      this.$emit('confirmSubmit')
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}

</script>
<style lang="scss" scoped>
#co-authorship-confirm-dialog {
  .co-authorship-confirm-block {
    padding: 25px 20px;
    box-sizing: border-box;
    .tips {
      border: 2px solid $key_color;
      border-radius: 4px;
      background: $key_color_bg;
      line-height: 50px;
      color: $font_color;
      padding: 0 22px;
    }
  }
}
</style>
